import { render, staticRenderFns } from "./news18.vue?vue&type=template&id=1e43fd7c&scoped=true&"
import script from "./news18.vue?vue&type=script&lang=js&"
export * from "./news18.vue?vue&type=script&lang=js&"
import style0 from "./news18.vue?vue&type=style&index=0&id=1e43fd7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e43fd7c",
  null
  
)

export default component.exports